export default "__VITE_ASSET__BYDR36no__"